import { useState } from 'react'
import JWTApi from 'datastore/APIWrapper'

const apiName = 'ApiGatewayRestApi'

type Params = {
  code: string
  email: string
}

export const useApiActivateCodeByEmail = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [isSuccess, setIsSuccess] = useState(false)

  const mutate = async ({ code, email }: Params) => {
    setIsLoading(true)
    setError(null)
    setIsSuccess(false)
    try {
      await JWTApi.post(apiName, '/premium/activate-code-by-email', {
        body: { code, email },
      })
      setIsSuccess(true)
    } catch (err: any) {
      const errorCode = err?.response?.data?.error || 'UnknownError'
      setError(errorCode)
    } finally {
      setIsLoading(false)
    }
  }

  return { mutate, isLoading, error, isSuccess }
}
